import { useExternalParams } from 'shared/hooks';
import { DateTime } from 'luxon';
import { PlacementsFilters } from './use-placements-page.types';

const initialValues = {
  fromDate: {
    initialValue: DateTime.now().startOf('day'),
    type: 'date',
  },
  company: {
    initialValue: undefined,
    type: 'string',
  },
  branchOffices: {
    initialValue: undefined,
    type: 'string_array',
  },
  departments: {
    initialValue: undefined,
    type: 'string_array',
  },
  jobType: {
    initialValue: undefined,
    type: 'array',
  },
  worker: {
    initialValue: undefined,
    type: 'string',
  },
  isFreelance: {
    initialValue: undefined,
    type: 'boolean',
  },
  isTempWork: {
    initialValue: undefined,
    type: 'boolean',
  },
} as const;

export const usePlacementsPage = () => {
  const [params, setParams] = useExternalParams(initialValues);

  const filters: PlacementsFilters = {
    fromDate: params.fromDate ?? undefined,
    company: params.company ?? undefined,
    branchOfficeIds: params.branchOffices ?? undefined,
    departmentIds: params.departments ?? undefined,
    jobType: (params.jobType as string[]) ?? undefined,
    worker: params.worker ?? undefined,
    isFreelance: params.isFreelance ?? undefined,
    isTempWork: params.isTempWork ?? undefined,
  };
  const selectedFilterCount = Object.values(filters).filter((value) => !!value).length;

  return {
    filters,
    setFilters: setParams,
    selectedFilterCount,
  };
};
